import React, { useState } from 'react';
import { Modal, Button, Select } from '@v2/components';
import { AddPimsDependencyModalProps } from './types';
import { styles } from './styles';

export const AddPimsDependencyModal: React.FC<AddPimsDependencyModalProps> = ({
  isOpen,
  onClose,
  onAdd,
  pims,
  existingPimsIds,
}) => {
  const [pimsId, setPimsId] = useState<string>('');
  const [minimumPimsVersionId, setMinimumPimsVersionId] = useState<string>('');

  const availablePims = pims.filter(p => !existingPimsIds.includes(p.id));
  const selectedPims = pims.find(p => p.id === pimsId);
  const versionOptions = (selectedPims?.versions ?? []).map(v => ({
    value: v,
    label: v,
  }));

  const handleAdd = () => {
    if (!pimsId) return;
    onAdd(pimsId, minimumPimsVersionId || null);
    setPimsId('');
    setMinimumPimsVersionId('');
    onClose();
  };

  const handleClose = () => {
    setPimsId('');
    setMinimumPimsVersionId('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Add PIMS Dependency"
      size="md"
      footer={
        <>
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAdd} disabled={!pimsId}>
            Add
          </Button>
        </>
      }>
      <div className={styles.content}>
        <Select
          id="add-pims-dependency-pims"
          label="PIMS"
          options={[
            { value: '', label: 'Select a PIMS' },
            ...availablePims.map(p => ({ value: p.id, label: p.name })),
          ]}
          value={pimsId}
          onChange={e => {
            setPimsId(e.target.value);
            setMinimumPimsVersionId('');
          }}
          aria-label="PIMS"
        />
        {selectedPims && selectedPims.versions?.length > 0 && (
          <Select
            id="add-pims-dependency-min-version"
            label="Minimum version (optional)"
            options={[{ value: '', label: 'None' }, ...versionOptions]}
            value={minimumPimsVersionId}
            onChange={e => setMinimumPimsVersionId(e.target.value)}
            aria-label="Minimum PIMS version"
          />
        )}
      </div>
    </Modal>
  );
};

export default AddPimsDependencyModal;
export type { AddPimsDependencyModalProps } from './types';
